import React from 'react'
import { IData } from '../../../interfaces/table'

import { Text as TextEl } from './styles'

const Text = ({ value }: IData) => (
  <TextEl>{value}</TextEl>
)

export default Text
